import React from 'react';

const Home = () => {
    return (
        <div>
            <h1>Welcome to the Home Page</h1>
            <p>This is a public page that anyone can access.</p>
        </div>
    );
};

export default Home;